import {Injectable} from '@angular/core';
import {ActivatedRouteSnapshot, CanActivate, Router, RouterStateSnapshot, UrlTree,} from '@angular/router';
import {AuthService} from '@app/auth/auth.service';
import {StorageService} from "@shared/storage.service";
import {Observable} from 'rxjs';
import {map} from "rxjs/operators";

@Injectable({
    providedIn: 'root',
})
export class AuthGuardService implements CanActivate {
    constructor(
        private auth: AuthService,
        private storageService: StorageService,
        private router: Router,
    ) {
    }

    canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot,): Observable<boolean | UrlTree> | Promise<boolean | UrlTree> | boolean | UrlTree {
        this.storageService.set('redirectUrl', state.url);
        return this.auth.isAuthenticated()
            .pipe(
                map(isLoggedIn => {
                    // return isLoggedIn;
                    return isLoggedIn ? true : this.router.createUrlTree(['/login']);
                })
            );
    }
}
